import { withCache } from '@/utils/cache';
import http from '@/utils/http';
import { INTERFACE } from '@/utils/INTERFACE';
import { getSite } from '@/utils/site';
import { getArriveId, getChannel } from '@/utils/siteDefs';


async function _isSaleOut(skus) {
	var pool={}
	var res = await http.jsonp.get(INTERFACE().isSaleOut, {
        skuIds:skus.join(','),
        channelFlag:getChannel(),
		siteFlag:getSite(),
		destCountryId:getArriveId()
	})
	for(let i=0;i<skus.length;i++){
		pool[skus[i]]=!!res.skuStockMap[skus[i]]
	}
	return pool
}

export const isSaleOut=withCache(_isSaleOut)
